export default {
  FETCH_FORM_TEMPLATES_BEGIN: 'FETCH_FORM_TEMPLATES_BEGIN',
  FETCH_FORM_TEMPLATES_SUCCESS: 'FETCH_FORM_TEMPLATES_SUCCESS',
  FETCH_FORM_TEMPLATES_FAILURE: 'FETCH_FORM_TEMPLATES_FAILURE',

  FETCH_DEFAULT_FORM_TEMPLATES_BEGIN: 'FETCH_DEFAULT_FORM_TEMPLATES_BEGIN',
  FETCH_DEFAULT_FORM_TEMPLATES_SUCCESS: 'FETCH_DEFAULT_FORM_TEMPLATES_SUCCESS',
  FETCH_DEFAULT_FORM_TEMPLATES_FAILURE: 'FETCH_DEFAULT_FORM_TEMPLATES_FAILURE',
};

